import {
  faPenToSquare,
  faPlus,
  faTrash,
  faSearch,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { EditDiaryPopup } from "../../components/popup/diarypopup";
import "../../css/Writingcenter.css";
import {
  deleteDiary,
  getBook,
  getUser,
  getWritingCenter,
  getDiaryAudio,
  deleteDiaryAudio,
} from "../../services/user-service";
import Deletebutton from "../my-estate/Deletebutton";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import {
  formatToUSdate
} from "../../components/Common";

export function WritingcenterDiaryPopup() {
  const navigate = useNavigate();
  const { books_id } = useParams();
  const [editingIndex] = useState(null);
  const [isBookOpen, setIsBookOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [showAudioConfirm, setShowAudioConfirm] = useState(false);
  const [audioId, setAudioId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const removeDiaryPage = (id) => {
    setShowConfirmation(true);
    setCurrentId(id);
  };

  const handleConfirmationClose = () => {
    setShowConfirmation(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleRemove = (params) => {
    setShowConfirmation(false);
    const { Id } = params;
    deleteDiary(Id)
      .then(() => {
        toast.success("Data deleted Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
//          navigate(`/user/writing-center`);
           const role = getUser().role;

           if (role === "TENANT_ADMIN" || role === "TENANT_USER") {
             navigate(`/organization/writing-center`);
           } else {
             navigate(`/user/writing-center`);
           }
      })
      .catch(() => {
        toast.error("Error deleting diary:");
      });
  };

  const handleBackToWritingCenter = () => {
    const role = getUser().role;
    if (role === "TENANT_ADMIN" || role === "TENANT_USER") {
      navigate(`/organization/writing-center`);
    } else {
      navigate(`/user/writing-center`);
    }
  };

  const deleteAudioFile = (id) => {
    deleteDiaryAudio(id)
      .then(() => {
        toast.success("Audio deleted successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setCategories(prev =>
           prev.map(item =>
             item.id === id ? { ...item, audio: null } : item
           )
         );

//         fetchData(); // refresh UI
      })
      .catch(() => {
        toast.error("Error deleting audio");
      });
  };

  const handleAudioDeleteConfirm = () => {
        if (!audioId) return;
    deleteAudioFile(audioId);
    setShowAudioConfirm(false);
  };

  const handleAudioDeleteCancel = () => {
    setShowAudioConfirm(false);
  };
  const user = getUser();
  const [imageSrc, setImageSrc] = useState("");
  const base64ToImage = () => {
    const base64String = user.image;
    const trimmedBase64 = base64String ? base64String.trim() : "";
    if (trimmedBase64) {
      setImageSrc(`data:image/jpeg;base64,${trimmedBase64}`);
    }
  };

  const URL = "../writing-center/";

  // start for editing props
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [editPopupEntry, setEditPopupEntry] = useState(null);

  const handleToggleEditPopupClose = () => {
    setEditPopupEntry(null);
    setShowEditPopup(false);
  };
  //    start searching the page in diary
  const [searchQuery, setSearchQuery] = useState("");

  const highlightSearchText = (text, query) => {
    if (!query) return text;
    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedQuery})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  // show data
  const [categories, setCategories] = useState([]);
  const [bookTitle, setBookTitle] = useState("");

  const fetchData = () => {
    const bookId = books_id;
    getBook(bookId)
      .then((res) => {
        if (res && res.length > 0) {
          setCategories(res);
          setIsBookOpen(true);
        } else {
          setIsBookOpen(false);
        }
      })
      .catch(() => {
        toast.error("Error while fetching the data for Writing Center:");
      });
  };

  const fetchBookTitle = () => {
    const userId = getUser().id;
    getWritingCenter(userId)
      .then((res) => {
        const currentBook = res.find((b) => String(b.id) === String(books_id));
        setBookTitle(currentBook ? currentBook.bookTitle : "");
      })
      .catch(() => {
        // silent fail is fine here, title just won't show
      });
  };
  const hasCreatedDate = categories.some((entry) => entry.createdDate);

  // page opening  animation
  const [show] = useState(true);
  const bookRef = useRef();
  useEffect(() => {
    if (searchQuery && bookRef.current && categories.length > 0) {
      const index = categories.findIndex(
        (entry) =>
          entry.heading?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          entry.note?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      if (index !== -1) {
        bookRef.current.pageFlip().turnToPage(index + 1);
      }
    }
  }, [searchQuery, categories]);
  useEffect(() => {
    fetchData();
    fetchBookTitle();
    base64ToImage();
  }, []);

  const EDITURL = "../writing-center/book-edit/";
  return (
    <>
      <div className={`your-component ${show ? "fade-in-element" : ""}`}>
        <div className="diary_home_page_base">
          <div className="user_diary1">
            <div>
              <div className="user_diary_base_page">
                <div className="diary-template">
                  <div className="diary_top_controls">
                    <Tooltip title="Back to Writing Center">
                      <button
                        className="diary_back_button"
                        onClick={handleBackToWritingCenter}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} />
                        Back
                      </button>
                    </Tooltip>
                  </div>
                  {isBookOpen && hasCreatedDate && (
                    <div className="diary_search_above_book">
                      <input
                        type="text"
                        placeholder="Search in diary..."
                        value={searchQuery}
                        className="diary_search_input_inline"
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  )}

                  <HTMLFlipBook
                    className="album-web"
                    ref={bookRef}
                    height={630}
                    width={500}
                    minWidth={300}
                    maxWidth={500}
                    showCover={true}
                    flippingTime={800}
                    style={{ margin: "0 auto" }}
                    mobileScrollSupport={true}
                    onFlip={(e) => handlePageChange(e.data)}
                    maxShadowOpacity={0.5}
                  >
                    <div className="cover" data-density="hard">
                      <div className="diary_coverpage_image ">
                        <div>
                          <img
                            src={imageSrc || "/img/avtar.jpg"}
                            alt="avtar_image"
                          />
                        </div>
                        <div>
                          <h1 className="book_heading_title">{bookTitle}</h1>
                        </div>
                      </div>
                    </div>
                    {categories.map((entry, index) => {
                      return (
                        <div
                          key={`category-${entry.id}`}
                          className="diary_page"
                        >
                          <div className="diary_page_content">
                            <div className="diary_heading_page">
                              <div className="diary-heading-image">
                                <img
                                  src={imageSrc || "/img/avtar.jpg"}
                                  alt="avtar_image"
                                />
                              </div>
                              <h1
                                className="diary_page_Heading"
                                dangerouslySetInnerHTML={{
                                  __html: highlightSearchText(
                                    entry.heading,
                                    searchQuery,
                                  ),
                                }}
                              ></h1>
                              <div className="diary_date">
                                <p>
                                  Created On:{" "}
                                  {formatToUSdate(entry.createdDate)}
                                </p>
                                <p>
                                  Updated On:{" "}
                                  {formatToUSdate(entry.updatedDate)}
                                </p>
                              </div>
                            </div>
                            <div
                              className="diary_body_text"
                              dangerouslySetInnerHTML={{
                                __html: highlightSearchText(
                                  entry.note,
                                  searchQuery,
                                ),
                              }}
                            ></div>
                            {/*                             {entry.id && ( */}
                            {entry.id && entry.audio !== null && (
                              <div
                                style={{
                                  marginTop: "10px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <audio
                                  key={entry.id + (entry.audio ? "has" : "no")}
                                  controls
                                  style={{
                                    width: "200px", // ✅ reduced width
                                    height: "35px", // optional compact height
                                  }}
                                >
                                  <source
                                    src={getDiaryAudio(entry.id)}
                                    type="audio/webm"
                                  />
                                </audio>
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  style={{
                                    cursor: "pointer",
                                    color: "red",
                                    marginLeft: "10px",
                                  }}
                                  title="Delete Audio"
                                  onClick={() => {
                                    setAudioId(entry.id);
                                    setShowAudioConfirm(true);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <div className="diary_buttons">
                            {editingIndex === entry.id ? (
                              <button className="user_diary_entry_edit_btn">
                                Editing...
                              </button>
                            ) : (
                              <>
                                <Link
                                  to={`${EDITURL}${entry.id}/${books_id}`}
                                  className="edit-button"
                                  style={{ marginRight: "10px" }}
                                >
                                  <Tooltip title="You Can edit your page by clicking here">
                                    <FontAwesomeIcon icon={faPenToSquare} />
                                  </Tooltip>
                                </Link>
                              </>
                            )}
                            <FontAwesomeIcon
                              onClick={() => removeDiaryPage(entry.id)}
                              className="delete-button-comp"
                              style={{ cursor: "pointer" }}
                              icon={faTrash}
                            />
                          </div>

                          <div className="diary_index">
                            <p>{index + 1}</p>
                          </div>
                        </div>
                      );
                    })}
                  </HTMLFlipBook>
                  {showEditPopup && editPopupEntry && (
                    <EditDiaryPopup
                      entry={editPopupEntry}
                      onClose={handleToggleEditPopupClose}
                    />
                  )}
                </div>
                <div>
                  <Link
                    to={`${URL}${books_id}`}
                    className="user_diary_entry_add_btn"
                  >
                    <Tooltip title="Click here to add new page to your book">
                      <FontAwesomeIcon icon={faPlus} shake size="xl" />
                    </Tooltip>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showConfirmation && (
        <Deletebutton
          handleRemove={handleRemove}
          Id={currentId}
          handleConfirmationClose={handleConfirmationClose}
        />
      )}

      {showAudioConfirm && (
        <Modal
          isOpen={showAudioConfirm}
          toggle={handleAudioDeleteCancel}
          style={{ paddingTop: "50px" }}
        >
          <ModalHeader toggle={handleAudioDeleteCancel}>
            <span style={{ color: "red", fontWeight: "500" }}>Warning !!!</span>
          </ModalHeader>

          <ModalBody style={{ color: "black", textAlign: "center" }}>
            Are you sure you want to delete this audio?
          </ModalBody>

          <ModalFooter>
            <Button
              className="confirm_delete_btn"
              onClick={handleAudioDeleteConfirm}
            >
              Yes
            </Button>

            <Button
              className="confirm_cancel_btn"
              onClick={handleAudioDeleteCancel}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
}